var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.wide?'px-10':'px-5',staticStyle:{"height":"40px"},attrs:{"color":"primary","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":function($event){return _vm.handleClick()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }